import { observer } from 'mobx-react-lite'
import { CampaignStatusConfig } from 'entities/Campaign/ui/CampaignStatus'
import type { IResponseCampaignStatus } from 'entities/Campaign'
import type { IWidgetProps } from 'widgets/FilterEditor/types/types'
import { WidgetStatus } from 'widgets/FilterEditor/ui/Widget/WidgetStatus'

export const WidgetCampaignStatus = observer((props: IWidgetProps) => {
  return (
    <WidgetStatus
      getConfigByStatus={(status) => CampaignStatusConfig[status as IResponseCampaignStatus]}
      {...props}
    />
  )
})
